import React from 'react';
import styled from 'styled-components';

const TooltipContentContainer = styled.div`
  padding: 15px;

  max-width: 500px;
  overflow-y: auto;
  max-height: 500px;

  h2 {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    font-size: 12px;
    color: #adb5bd;
    margin-bottom: 9px;
  }

  p {
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #4b4b4b;
    line-height: 1.8;
    :not(:last-child) {
      margin-bottom: 7px;
    }
  }

  .container3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px 5px;
  }
`;

const ContentTooltip = ({ values, title }) => {
  if (!values) {
    values = [];
  }
  return (
    <TooltipContentContainer>
      <h2>{title}</h2>
      {values && values.length > 15 ? (
        <div className="container3">
          {values.map((competitor, index) => (
            <p key={index}>{competitor}</p>
          ))}
        </div>
      ) : (
        values.map((competitor, index) => <p key={index}>{competitor}</p>)
      )}
    </TooltipContentContainer>
  );
};

export default ContentTooltip;
